export enum Priority {
  INFO,
  LOW,
  MEDIUM,
  HIGH,
}
export const VINMEC_CONDITION_PROGRAM = 'https://www.vinmec.com/vie/bai-viet/chuong-trinh-cham-soc-suc-khoe-vinmec';
export const VINMEC_POLICY_PRINCIPAL =
  'https://www.vinmec.com/vie/bai-viet/chinh-sach-quyen-rieng-tu-cua-cong-ty-benh-vien-da-khoa-quoc-te-vinmec-vi';
